// extracted by mini-css-extract-plugin
export default {"cls1":"ArzmRCvhYnD3JADQmAjJ","cls2":"kxdoAZF7dQXPNBhhL8oH ArzmRCvhYnD3JADQmAjJ"};